import { render, staticRenderFns } from "./transferredModal.vue?vue&type=template&id=6785c7a4&scoped=true"
import script from "./transferredModal.vue?vue&type=script&lang=js"
export * from "./transferredModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6785c7a4",
  null
  
)

export default component.exports